import { createStore } from "./createStore";

const base = (set) => ({
  isLoading: false,
  setLoading: (loading) => set({ isLoading: loading }),
});

export const useLoadStore = createStore("LoadStore", base);
